import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core'
import CancelButton from 'app/components/buttons/CancelButton'
import DeleteButton from 'app/components/buttons/DeleteButton'
import clsx from 'clsx'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'
import { FormattedMessage } from 'react-intl'

export default (props) => {
  const { state, classes, toggleDialogs, DELETE_DIALOG, handleDeleteGroups } =
    props

  const mobileClasses = useMobileStyle()

  return (
    <Dialog
      open={state.isOpenDeleteDialog}
      className={clsx(classes.groupDialog, mobileClasses.lessPaddingMobile)}
    >
      <DialogTitle id="alert-dialog-title" className={classes.groupDeleteTitle}>
        <FormattedMessage id="profile.info.warning" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <FormattedMessage id="profile.info.deleteall" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={() => {
            toggleDialogs(DELETE_DIALOG, false)
          }}
          className={mobileClasses.modalBtn}
        />
        <DeleteButton
          onClick={handleDeleteGroups}
          className={mobileClasses.modalBtn}
        />
      </DialogActions>
    </Dialog>
  )
}
